import { render, staticRenderFns } from "./PauseOrdersModal.vue?vue&type=template&id=dd758b6a"
import script from "./PauseOrdersModal.vue?vue&type=script&lang=ts"
export * from "./PauseOrdersModal.vue?vue&type=script&lang=ts"
import style0 from "./PauseOrdersModal.vue?vue&type=style&index=0&id=dd758b6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports